module.exports = __webpack_public_path__ + "img/incomeFromPreviousEmployer.8a59107c.svg";